import { Directive, OnDestroy, OnInit } from '@angular/core';
import { CompareHelper } from '@barthauer/abc/core';
import { Subscription } from 'rxjs';
import { BasysMapFrameService } from '../basys-map-frame.service';
import { ViewStateChangeArgType } from '../models/viewState.model';

@Directive()
export abstract class PanelComponent implements OnInit, OnDestroy {
  //publish basic mechanisms. its a dream ;-) love JS *vomiting*
  Object = Object;
  alert = alert;
  console = console;
  CompareHelper = CompareHelper;

  private scrollViewPortElement: HTMLElement;
  protected scrollViewPortElementName: string;
  protected subscriptions: Subscription[] = [];
  protected get scrollViewPortHeightVerticalMargin(): number {
    return 150;
  }
  public frame: BasysMapFrameService;
  constructor() {}

  protected init(frame: BasysMapFrameService) {
    this.frame = frame;
    this.subscriptions.push(
      this.frame.lib.onViewStateChanged().subscribe((args) => {
        switch (args.type) {
          case ViewStateChangeArgType.BottomSheetPanelOpened:
          case ViewStateChangeArgType.BottomSheetPanelSizeChanged: {
            this.updateSize();
            break;
          }
        }
      })
    );
  }
  ngOnInit() {
    if (this.scrollViewPortElementName) {
      // console.log('PanelComponent_ngOnInit');
      this.scrollViewPortElement = document.getElementById(this.scrollViewPortElementName);
      if (this.scrollViewPortElement) {
        const hammer = new Hammer(this.scrollViewPortElement, { touchAction: 'pan-x pan-y' });

        hammer.get('pan').set({ direction: Hammer.DIRECTION_VERTICAL });
        hammer.on('panstart', (event: any) => {
          this.frame.lib.raiseViewStateChanged({ type: ViewStateChangeArgType.ClientPanStart });
        });
        hammer.on('panend pancancel', (event: any) => {
          this.frame.lib.raiseViewStateChanged({ type: ViewStateChangeArgType.ClientPanEnd });
        });
      }
    }
  }

  protected updateSize() {
    if (this.scrollViewPortElement && this.frame.lib.currentBottomSheetPanelHeight) {
      const newHeight = this.frame.lib.currentBottomSheetPanelHeight - this.scrollViewPortHeightVerticalMargin;
      this.scrollViewPortElement.style.height = newHeight + 'px';
      //this.scrollViewPortElement.style.setProperty('transform', 'translateY(' + newHeight + "px)", "important");
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((element) => {
      element.unsubscribe();
    });
  }
}
